import React from 'react'
import {isEmpty} from 'lodash'

import errors from '../../lib/errors.js'
import ErrorDialog from '../UI/ErrorDialog'
import BackButton from '../UI/BackButton'
import PageTitle from '../UI/PageTitle'
import LinearLoader from '../UI/LinearLoader'

import Resource from '../../stores/resource'
import DirectorNotFound from "./DirectorNotFound";
import EditDirector from "./EditDirector";
const DirectorStore = Resource('directors')

class EditDirectorPage extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      director: {},
      error: '',
      loading: true
    }
  }

  componentWillMount() {
    DirectorStore.findBy({id: this.props.match.params.id})
    .then((result) => this.setState({
      director: result.data,
      loading: false
    }))
    .catch((error) => this.setState({
      director: {},
      error: errors.unpack(error),
      loading: false
    }))
  }

  _closeErrorDialog = () => this.setState({error: ''})

  render() {
    const {
      director,
      error,
      loading
    } = this.state

    if (loading) return <LinearLoader />
    if (isEmpty(director)) return <DirectorNotFound/>

    return (
      <section>
        <header>
          <PageTitle>
            Edit Director
          </PageTitle>
        </header>

        <EditDirector director={director} />
        <br/>
        <BackButton/>

        <ErrorDialog
          open={Boolean(error)}
          closeCallback={this._closeErrorDialog}>
          <p>
            <strong>Error:</strong> {error}
          </p>
        </ErrorDialog>
      </section>
    )
  }

}

export default EditDirectorPage



// WEBPACK FOOTER //
// ./src/components/Directors/EditDirectorPage.jsx